<ng-container *ngIf="errorMessage !== ''">
    <head>
        <title>Error</title>
    </head>
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ errorMessage }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<head *ngIf="mostrar && mostrar !== undefined && errorMessage === ''">
    <title>{{pageTitle}}</title>
</head>

<body *ngIf="mostrar && mostrar !== undefined && errorMessage === ''">
    <!--Header-->
    <mat-toolbar class="toolbar">
        <button mat-mini-fab class="menu-icon" (click)="opened=!opened">
            <mat-icon>{{ !opened ? 'menu' : 'menu' }}</mat-icon>
        </button>
        <!-- <img class="home-img" src="assets\images\logoHome.svg"> -->
        <img routerLink="/home/establecimientos" class="home-img" src="assets\images\logoHomeBlanco.svg">
        <span class="horaFechas">{{sFechaActual}} - {{ time | date: 'HH:mm:ss' }}</span>
    </mat-toolbar>
    

    <!--Sidenav-->
    <!--hasBackdrop es una función del sidenav-container que indica si cuando se abre el sidenav
    se ensombrece o no el contenido. Lo hacemos responsive desde el .ts para que cuando la pantalla
    sea pequeña es ensombrezca y cuando sea grande no-->
    <mat-sidenav-container [hasBackdrop]="hasBackdrop">
        <!--disableClose hace que la ventana no se cierre aunque clickes algo del content o la tecla 
        Esc, que es lo que buscamos cuando la pantalla es grande, cuando es pequeña sigue abriendose
        y cerrandose clickando el menu-icon en el content o con la tecla Esc-->
        <mat-sidenav #sidenav [(opened)]="opened" [mode]="mode" [disableClose]="disableClose">

            <!--User information-->
            <div class="user-info">
                <div class="image">
                    <img src="assets/images/user-databeer-amarillo.png" alt="User"/>
                </div>
                <div class="info-container">
                    <div class="name" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{userName}}</div>
                    <div class="email">{{userEmail}}</div>
                    <button mat-button [matMenuTriggerFor]="userMenu">
                        <i class="material-icons">keyboard_arrow_down</i>
                    </button>
                    <mat-menu #userMenu="matMenu">
                        <!--Lazy rendering para evitar que se inicialice hasta que que se abra el menu-->
                        <ng-template matMenuContent>
                            <button mat-menu-item routerLink="/perfil">
                                <mat-icon class="negro">person</mat-icon>
                                <span class="negro">Perfil</span>
                            </button>
                            <button mat-menu-item (click)="logout()">
                                <mat-icon class="amarillo">input</mat-icon>
                                <span class="amarillo">Salir</span>
                            </button>
                        </ng-template>
                    </mat-menu>
                </div>
            </div>

            <!--Menu-->
            <div class="menu">
                <div class="menu-header">Navegación principal</div>

                <mat-nav-list>
                    <a mat-list-item routerLink="/home/establecimientos" class="menu-home">
                        <mat-icon class="material-icons-home" [style.color]="panelSelectionMap['homeE'] ? '#FBB040' : '#FBB040'">home</mat-icon>
                        <span class="menu-home-text" [ngClass]="{'seleccionado': panelSelectionMap['homeE']}">&nbsp;Home</span>
                        <mat-icon class="material-icons-Est" [style.color]="panelSelectionMap['homeE'] ? '#FBB040' : '#555'">store</mat-icon>
                    </a>
                </mat-nav-list>

                <mat-nav-list *ngIf="this.userData.pro_id === 4" [ngStyle]="{'margin-top.px': -20}">
                    <a mat-list-item routerLink="/home" class="menu-home">
                        <mat-icon class="material-icons-home" [style.color]="panelSelectionMap['homeD'] ? '#FBB040' : '#FBB040'">home</mat-icon>
                        <span class="menu-home-text" [ngClass]="{'seleccionado': panelSelectionMap['homeD']}">&nbsp;Home</span>
                        <mat-icon class="material-icons-Est" [style.color]="panelSelectionMap['homeD'] ? '#FBB040' : '#555'">devices_other</mat-icon>
                    </a>
                </mat-nav-list>

                <mat-accordion displayMode ='flat' hideToggle>
                    <mat-expansion-panel (opened)="togglePanelExpansion('establecimientos')" (closed)="togglePanelExpansion('establecimientos')"
                    (opened)="togglePanelSelection('establecimientos')" (closed)="togglePanelSelection('establecimientos')" [expanded]="panelExpandidoEstablecimientos">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['establecimientos']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['establecimientos'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">store</mat-icon>
                                Establecimientos
                                <mat-icon class="custom-icon">{{ panelSelectionMap['establecimientos'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/establecimientos/agregar" *ngIf = "this.userData.pro_id == 4 || this.userData.pro_id == 1">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['establecimientosNuevo'], 'menu-btn': !panelSelectionMap['establecimientosNuevo']}">Nuevo</span>
                            </a>
                            <a mat-list-item routerLink="/establecimientos">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['establecimientosAdmin'], 'menu-btn': !panelSelectionMap['establecimientosAdmin']}">Administrar</span>
                            </a>
                            <a mat-list-item routerLink="/establecimientos/mapa">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['establecimientosMapa'], 'menu-btn': !panelSelectionMap['establecimientosMapa']}">Mapa</span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('dispositivos')" (closed)="togglePanelExpansion('dispositivos')"
                    (opened)="togglePanelSelection('dispositivos')" (closed)="togglePanelSelection('dispositivos')" [expanded]="panelExpandidoDispositivos">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['dispositivos']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['dispositivos'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">devices_other</mat-icon>
                                Dispositivos
                                <mat-icon class="custom-icon">{{ panelSelectionMap['dispositivos'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/dispositivos/agregar" *ngIf="userData.pro_id == 4">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['dispositivosNuevo'], 'menu-btn': !panelSelectionMap['dispositivosNuevo']}">Nuevo</span>
                            </a>
                            <a mat-list-item routerLink="/dispositivos">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['dispositivosAdmin'], 'menu-btn': !panelSelectionMap['dispositivosAdmin']}">Administrar</span>
                            </a>
                            <!--<a mat-list-item routerLink="/alarmas">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['dispositivosAlarmas'], 'menu-btn': !panelSelectionMap['dispositivosAlarmas']}">Alarmas</span>
                            </a>-->
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <!--TANQUES-->
                    <mat-expansion-panel (opened)="togglePanelExpansion('tanques')" (closed)="togglePanelExpansion('tanques')"
                    (opened)="togglePanelSelection('tanques')" (closed)="togglePanelSelection('tanques')" [expanded]="panelExpandidoTanques">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['tanques']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['tanques'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">settings_input_svideo</mat-icon>
                                Tanques
                                <mat-icon class="custom-icon">{{ panelSelectionMap['tanques'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/tanques/agregar" *ngIf = "this.userData.pro_id == 4 || this.userData.pro_id == 1">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['tanquesNuevo'], 'menu-btn': !panelSelectionMap['tanquesNuevo']}">Nuevo</span>
                            </a>
                            <a mat-list-item routerLink="/tanques">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['tanquesAdmin'], 'menu-btn': !panelSelectionMap['tanquesAdmin']}">Administrar</span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('cervezas')" (closed)="togglePanelExpansion('cervezas')"
                    (opened)="togglePanelSelection('cervezas')" (closed)="togglePanelSelection('cervezas')" [expanded]="panelExpandidoCervezas">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['cervezas']}">
                                <img class="material-icons" *ngIf="panelSelectionMap['cervezas']" src="assets/images/icons8-beer-96-Amarillo.png" 
                                    height="25" 
                                />
                                <img class="material-icons" *ngIf="!panelSelectionMap['cervezas']" src="assets/images/icons8-beer-96-Gris.png" 
                                    height="25" 
                                />
                                Productos
                                <mat-icon class="custom-icon">{{ panelSelectionMap['cervezas'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/cervezas/agregar" *ngIf = "this.userData.pro_id == 4 || this.userData.pro_id == 1">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['cervezasNuevo'], 'menu-btn': !panelSelectionMap['cervezasNuevo']}">Nuevo</span>
                            </a>
                            <a mat-list-item routerLink="/cervezas">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['cervezasAdmin'], 'menu-btn': !panelSelectionMap['cervezasAdmin']}">Administrar</span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('alarmas')" (closed)="togglePanelExpansion('alarmas')"
                    (opened)="togglePanelSelection('alarmas')" (closed)="togglePanelSelection('alarmas')" [expanded]="panelExpandidoAlarmas">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['alarmas']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['alarmas'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">notifications</mat-icon>
                                Alarmas
                                <mat-icon class="custom-icon">{{ panelSelectionMap['alarmas'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/alarmas/activas">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['alarmasActivas'], 'menu-btn': !panelSelectionMap['alarmasActivas']}">
                                    Activas
                                </span>
                            </a>
                            <a mat-list-item routerLink="/alarmas/historial">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['alarmasHistorial'], 'menu-btn': !panelSelectionMap['alarmasHistorial']}">
                                    Historial
                                </span>
                            </a>
                            <a mat-list-item routerLink="/configuracion/alarmas">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['alarmasConfiguracion'], 'menu-btn': !panelSelectionMap['alarmasConfiguracion']}">
                                    Configuración Actual
                                </span>
                            </a>
                            <a mat-list-item routerLink="/establecimientos/alarmas" *ngIf = "this.userData.pro_id == 4 || this.userData.pro_id == 2">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['establecimientosAlarmas'], 'menu-btn': !panelSelectionMap['establecimientosAlarmas']}">
                                    Establecer alarmas
                                </span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('pedidos')" (closed)="togglePanelExpansion('pedidos')"
                    (opened)="togglePanelSelection('pedidos')" (closed)="togglePanelSelection('pedidos')" [expanded]="panelExpandidoPedidos"
                    *ngIf="userData.pro_id == 2 || userData.pro_id == 4 || userData.pro_id == 1">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['pedidos']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['pedidos'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">assignment</mat-icon>
                                Pedidos
                                <mat-icon class="custom-icon">{{ panelSelectionMap['pedidos'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/pedido/agregar"  *ngIf="userData.pro_id == 2 || userData.pro_id == 4">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['nuevoPedido'], 'menu-btn': !panelSelectionMap['nuevoPedido']}">
                                    Nuevo
                                </span>
                            </a>
                            <a mat-list-item routerLink="/pedidos" *ngIf="userData.pro_id == 4 || userData.pro_id == 2 || userData.pro_id == 1">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['listaPedidos'], 'menu-btn': !panelSelectionMap['listaPedidos']}">
                                    Lista
                                </span>
                            </a>
                            <!--<a mat-list-item routerLink="/recargas/historial">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['tanquesRecargas'], 'menu-btn': !panelSelectionMap['tanquesRecargas']}">
                                    Recargas
                                </span>
                            </a>-->
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('recargas')" (closed)="togglePanelExpansion('recargas')"
                    (opened)="togglePanelSelection('recargas')" (closed)="togglePanelSelection('recargas')" [expanded]="panelExpandidoRecargas" routerLink="/recargas/historial">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['recargas']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['recargas'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">sync</mat-icon>
                                Recargas
                                <mat-icon class="custom-icon">{{ panelSelectionMap['recargas'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('clientes')" (closed)="togglePanelExpansion('clientes')"
                    (opened)="togglePanelSelection('clientes')" (closed)="togglePanelSelection('clientes')" [expanded]="panelExpandidoClientes"
                    *ngIf="userData.pro_id == 4">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['clientes']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['clientes'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">group</mat-icon>
                                Clientes
                                <mat-icon class="custom-icon">{{ panelSelectionMap['clientes'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/clientes/agregar">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['clientesNuevo'], 'menu-btn': !panelSelectionMap['clientesNuevo']}">Nuevo</span>
                            </a>
                            <a mat-list-item routerLink="/clientes">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['clientesLista'], 'menu-btn': !panelSelectionMap['clientesLista']}">Administrar</span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('usuarios')" (closed)="togglePanelExpansion('usuarios')"
                    (opened)="togglePanelSelection('usuarios')" (closed)="togglePanelSelection('usuarios')" [expanded]="panelExpandidoUsuarios"
                    *ngIf="userData.pro_id == 4 || userData.pro_id == 1">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['usuarios']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['usuarios'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">perm_identity</mat-icon>
                                Usuarios
                                <mat-icon class="custom-icon">{{ panelSelectionMap['usuarios'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/usuarios/agregar">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['usuariosNuevo'], 'menu-btn': !panelSelectionMap['usuariosNuevo']}">Nuevo</span>
                            </a>
                            <a mat-list-item routerLink="/usuarios">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['usuariosLista'], 'menu-btn': !panelSelectionMap['usuariosLista']}">Administrar</span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('estadisticas')" (closed)="togglePanelExpansion('estadisticas')"
                    (opened)="togglePanelSelection('estadisticas')" (closed)="togglePanelSelection('estadisticas')" [expanded]="panelExpandidoEstadisticas">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a [ngClass]="{'seleccionado': panelSelectionMap['estadisticas']}">
                                <mat-icon class="material-icons" [style.color]="panelSelectionMap['estadisticas'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">pie_chart_outlined</mat-icon>
                                Estadísticas
                                <mat-icon class="custom-icon">{{ panelSelectionMap['estadisticas'] ? 'remove' : 'add' }}</mat-icon>
                            </a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/estadisticas/consumo">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['estadisticasConsumo'], 'menu-btn': !panelSelectionMap['estadisticasConsumo']}">Consumo</span>
                            </a>
                            <a mat-list-item routerLink="/estadisticas" *ngIf="userData.pro_id == 4">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['estadisticasGlobales'], 'menu-btn': !panelSelectionMap['estadisticasGlobales']}">Usuarios</span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="togglePanelExpansion('vistas')" (closed)="togglePanelExpansion('vistas')"
                    (opened)="togglePanelSelection('vistas')" (closed)="togglePanelSelection('vistas')" [expanded]="panelExpandidoVistas"
                    *ngIf="userData.pro_id == 4 || userData.cliente_id == 6 || userData.cliente_id == 3">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <a [ngClass]="{'seleccionado': panelSelectionMap['vistas']}">
                                    <mat-icon class="material-icons" [style.color]="panelSelectionMap['vistas'] ? '#FBB040' : '#555'" [attr.nonce]="cspNonceV">link</mat-icon>
                                    Vistas personalizadas
                                    <mat-icon class="custom-icon">{{ panelSelectionMap['vistas'] ? 'remove' : 'add' }}</mat-icon>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item routerLink="/mega" *ngIf="userData.pro_id == 4 || userData.cliente_id == 3" target="_blank">
                                <span class="menu-btn">MEGA</span>
                            </a>
                            <a mat-list-item routerLink="/canalejas" *ngIf="userData.pro_id == 4 || userData.cliente_id == 6">
                                <span [ngClass]="{'seleccionado-sec': panelSelectionMap['vistasCanalejas'], 'menu-btn': !panelSelectionMap['vistasCanalejas']}">Mercado Canalejas</span>
                            </a>
                        </mat-nav-list>
                    </mat-expansion-panel>

                    <!--<mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <a><mat-icon class="material-icons">settings</mat-icon>Configuración</a>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-nav-list>
                            <a mat-list-item><span class="menu-btn">Ayuda</span></a>
                        </mat-nav-list>
                    </mat-expansion-panel>-->
                </mat-accordion>
            
                <!--<a mat-list-item><mat-icon class="material-icons">devices_other</mat-icon>Dispositivos</a>
                <a mat-list-item><mat-icon class="material-icons">group</mat-icon>Clientes</a>
                <a mat-list-item><mat-icon class="material-icons">perm_identity</mat-icon>Usuarios</a>
                <a mat-list-item><mat-icon class="material-icons">pie_chart_outlined</mat-icon>Estadísticas</a>
                <a mat-list-item><mat-icon class="material-icons">link</mat-icon>Vistas personalizadas</a>
                <a mat-list-item><mat-icon class="material-icons">settings</mat-icon>Configuración</a>--> 
            </div>

            <!--Footer-->
            <div class="legal">
                <div class="copyright">
                    &copy; 2025 <a href="javascript:void(0);">Perfect Numbers</a>
                </div>
                <div class="version">
                    <b class="tam-texto">Versión: </b> 2.1.0
                </div>
            </div>
        </mat-sidenav>

        <!--Page Main Content-->
        <mat-sidenav-content #sidenavContent role="region" *ngIf="errorMessage == ''">
            <!--Dependiendo del path se carga un componente u otro en mat-sidenav-content-->
            <!--Sidenav-->
            <ng-container *ngIf="currentPath === '/home'">
                <app-home-content></app-home-content>
            </ng-container>
            <ng-container *ngIf="currentPath === '/home/establecimientos'">
                <app-home-establecimientos></app-home-establecimientos>
            </ng-container>
            <ng-container *ngIf="currentPath === '/perfil'">
                <app-perfil [userData]="userData"></app-perfil>
            </ng-container>
            <ng-container *ngIf="currentPath === '/establecimientos'">
                <app-establecimientos></app-establecimientos>
            </ng-container>
            <ng-container *ngIf="currentPath === '/establecimientos/agregar'">
                <app-agregar-establecimiento></app-agregar-establecimiento>
            </ng-container>
            <ng-container *ngIf="currentPath === '/establecimientos/mapa'">
                <app-mapa-establecimientos></app-mapa-establecimientos>
            </ng-container>
            <ng-container *ngIf="currentPath === '/establecimientos/alarmas'">
                <app-agregar-alarmas></app-agregar-alarmas>
            </ng-container>
            <ng-container *ngIf="currentPath === '/dispositivos'">
                <app-dispositivos [userData]="userData"></app-dispositivos>
            </ng-container>
            <ng-container *ngIf="currentPath === '/dispositivos/agregar'">
                <app-agregar-dispositivo [userId]="userId"></app-agregar-dispositivo>
            </ng-container>
            <ng-container *ngIf="currentPath === '/alarmas/activas'">
                <app-alarmas></app-alarmas>
            </ng-container>
            <ng-container *ngIf="currentPath === '/alarmas/historial'">
                <app-alarmas-historial></app-alarmas-historial>
            </ng-container>
            <ng-container *ngIf="currentPath === '/configuracion/alarmas'">
                <app-configuracion-alarmas></app-configuracion-alarmas>
            </ng-container>
            <ng-container *ngIf="currentPath === '/tanques'">
                <app-tanques></app-tanques>
            </ng-container>
            <ng-container *ngIf="currentPath === '/tanques/agregar'">
                <app-agregar-tanque></app-agregar-tanque>
            </ng-container>
            <ng-container *ngIf="currentPath === '/cervezas/agregar'">
                <app-agregar-cerveza></app-agregar-cerveza>
            </ng-container>
            <ng-container *ngIf="currentPath === '/cervezas'">
                <app-cervezas></app-cervezas>
            </ng-container>
            <ng-container *ngIf="currentPath === '/pedido/agregar'">
                <app-agregar-pedido></app-agregar-pedido>
            </ng-container>
            <ng-container *ngIf="currentPath === '/pedidos'">
                <app-pedidos></app-pedidos>
            </ng-container>
            <ng-container *ngIf="currentPath === '/recargas/historial'">
                <app-recargas-historial></app-recargas-historial>
            </ng-container>
            <ng-container *ngIf="currentPath === '/clientes'">
                <app-clientes></app-clientes>
            </ng-container>
            <ng-container *ngIf="currentPath === '/clientes/agregar'">
                <app-agregar-cliente></app-agregar-cliente>
            </ng-container>
            <ng-container *ngIf="currentPath === '/usuarios'">
                <app-usuarios></app-usuarios>
            </ng-container>
            <ng-container *ngIf="currentPath === '/usuarios/agregar'">
                <app-agregar-usuario></app-agregar-usuario>
            </ng-container>
            <ng-container *ngIf="currentPath === '/estadisticas'">
                <app-estadisticas></app-estadisticas>
            </ng-container>
            <ng-container *ngIf="currentPath === '/estadisticas/consumo'">
                <app-estadisticas-consumo></app-estadisticas-consumo>
            </ng-container>
            <ng-container *ngIf="currentPath === '/canalejas'">
                <app-mercado-canalejas></app-mercado-canalejas>
            </ng-container>
            <!--Home-content-->
            <ng-container *ngIf="urlValidaVerDispositivo()">
                <!--Enviando al componente el userId nos ahorramos una llamada a la api-->
                <app-ver-dispositivo></app-ver-dispositivo>
                <!--[userData]="userData"-->
            </ng-container>
            <ng-container *ngIf="urlValidarVerDatosDispositivo()">
                <app-ver-dispositivo-datos [userId]="userId"></app-ver-dispositivo-datos>
            </ng-container>
            <ng-container *ngIf="urlValidaEditarDispositivo()">
                <app-editar-dispositivo [userId]="userId"></app-editar-dispositivo>
            </ng-container>
            <ng-container *ngIf="urlValidaEditarTanque()">
                <app-editar-tanque></app-editar-tanque>
            </ng-container>
            <ng-container *ngIf="urlValidaVerTanque()">
                <app-ver-tanque></app-ver-tanque>
            </ng-container>
            <ng-container *ngIf="urlValidaEditarCerveza()">
                <app-editar-cerveza></app-editar-cerveza>
            </ng-container>
            <ng-container *ngIf="urlValidaVerCerveza()">
                <app-ver-cerveza></app-ver-cerveza>
            </ng-container>
            <ng-container *ngIf="urlValidaEditarUsuario()">
                <app-editar-usuario></app-editar-usuario>
            </ng-container>
            <ng-container *ngIf="urlValidaEditarCliente()">
                <app-editar-cliente></app-editar-cliente>
            </ng-container>
            <ng-container *ngIf="urlValidaVerEstablecimiento()">
                <app-ver-establecimiento></app-ver-establecimiento>
            </ng-container>
            <ng-container *ngIf="urlValidaVerEstablecimientoCompleto()">
                <app-ver-establecimiento-completo></app-ver-establecimiento-completo>
            </ng-container>
            <ng-container *ngIf="urlValidaEditarEstablecimiento()">
                <app-editar-establecimiento></app-editar-establecimiento>
            </ng-container>
        </mat-sidenav-content>
        <!--Error al cargar los datos del usuario-->
        <mat-sidenav-content *ngIf="errorMessage != ''">
            <div class="mensaje-error-container">
                <div class="mensaje-error">{{ errorMessage }}</div>
                <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</body>

<ng-container *ngIf="!mostrar && mostrar !== undefined &&  errorMessage === ''">
    <app-page-not-found></app-page-not-found>
</ng-container>
